module.exports = __webpack_public_path__ + "static/media/shiraz_uni.f77efd53.jpeg";